import { useCallback, useState } from "react";
import { useNavigate } from "react-router";

import type { ChillnnStudioDriver } from "@/lib/chillnn-studio-driver";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import type { ComponentProps } from "react";

type ChillnnStudioDriverProps = ComponentProps<typeof ChillnnStudioDriver>;

type Props = {
	editorProps: ChillnnStudioDriverProps["editorProps"];

	/**
	 * saveAndExitの際に遷移するページのパス
	 */
	pagePathAfterSaveAndExit: string;

	shouldTransitionBlockStatusMethods: {
		shouldTransitionBlockStatus: boolean;
		activateTransitionBlockStatus: () => void;
		deactivateTransitionBlockStatus: () => void;
	};
};

type UseDesignSnackEditUUIDSnackType = {
	isShowBaseSettingDialog: boolean;
	handleClickBaseSettingSaveButton: () => void;

	editorProps: ChillnnStudioDriverProps["editorProps"];
};

export const useSnackAndHPBSnackEditUUID = ({
	pagePathAfterSaveAndExit,
	editorProps,
	shouldTransitionBlockStatusMethods,
}: Props): UseDesignSnackEditUUIDSnackType => {
	const { shouldTransitionBlockStatus, deactivateTransitionBlockStatus } = shouldTransitionBlockStatusMethods;

	useTransitionBlock(shouldTransitionBlockStatus);

	// 編集の場合、初期描画時にはダイアログを表示しない（初期値：false）
	const [isShowBaseSettingDialog, setIsShowBaseSettingDialog] = useState(false);
	const { callbackSave: _callbackSave, callbackSaveAndExit: _callbackSaveAndExit } = editorProps;

	const navigate = useNavigate();

	const callbackSaveAndExit = useCallback(async () => {
		setIsShowBaseSettingDialog(true);
		await new Promise<void>(() => {});
	}, []);

	const handleClickBaseSettingSaveButton = useCallback(async () => {
		deactivateTransitionBlockStatus();
		setIsShowBaseSettingDialog(false);

		await _callbackSaveAndExit();

		navigate(pagePathAfterSaveAndExit);
	}, [deactivateTransitionBlockStatus, _callbackSaveAndExit, navigate, pagePathAfterSaveAndExit]);

	const callbackSave = useCallback(async () => {
		deactivateTransitionBlockStatus();

		await _callbackSave();
	}, [_callbackSave, deactivateTransitionBlockStatus]);

	return {
		isShowBaseSettingDialog,
		handleClickBaseSettingSaveButton,

		editorProps: {
			...editorProps,
			callbackSaveAndExit,
			callbackSave,
		},
	};
};
